import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import msgConstants from '../../../../constants/msgConstants'
import TitulosManager from '../../../../services/api/titulos/titulosManager'
import { loadingReset, loadingUpdate } from '../../../../store/actions/loadingAction'
import { StatusProcessamento } from '../../../../types/genericoType'
import { BuscarTitulosForm, CardTitulos, ValorGerados } from '../../../../types/titulosTypes'
import { dataInicialMes, getDataAtualFormatada } from '../../../../utils/stringUtils'
import { titulosGeradosStyles } from './TitulosGerados.styles'
import { TitulosGeradosProps } from './TitulosGerados.View'

export function titulosGeradosIO({
  dataFinalTitulosGerados,
  dataFinalTitulosGeradosAlterada,
  dataInicialTitulosGeradosAlterada,
  setCarregarBotao,
  setDataInicialTitulosGerados,
  setDataFinalTitulosGerados,
  dataInicialTitulosGerados,
  gerarRelatorioTitulosGerados
}: TitulosGeradosProps) {
  const dispatch = useDispatch()
  const dataInicialMesAtual = dataInicialMes()
  const diaAtual = getDataAtualFormatada()
  const [titulosGerados, setTitulosGerados] = useState<ValorGerados>({} as ValorGerados)
  const [valorSetTimeOut, setValorSetTimeOut] = useState<number>(0)

  useEffect(() => {
    estadoInicialTela()
  }, [dataInicialMesAtual, diaAtual, dispatch])

  useEffect(() => {
    buscaConstanteTitulos(titulosGerados, () => handleBuscarTitulosGerados())
  }, [titulosGerados])

  function handleBuscarTitulosGerados(): Promise<void> {
    return buscarTitulosGerados(
      dataInicialTitulosGerados,
      dataFinalTitulosGerados,
      setDataInicialTitulosGerados,
      setDataFinalTitulosGerados,
      setTitulosGerados,
      dataInicialTitulosGeradosAlterada,
      dataFinalTitulosGeradosAlterada
    )
  }

  const buscarTitulosGerados = async (
    dataInicial: string,
    dataFinal: string,
    setDataInicial: React.Dispatch<React.SetStateAction<string>>,
    setDataFinal: React.Dispatch<React.SetStateAction<string>>,
    setTitulos: React.Dispatch<React.SetStateAction<ValorGerados>>,
    dataInicialAlterada: string,
    dataFinalAlterada: string
  ) => {
    await TitulosManager.buscarTitulosGerados(dataInicial, dataFinal)
      .then((response: ValorGerados) => {
        if (response.processamento == undefined || response.processamento.status == StatusProcessamento.PROCESSANDO) {
          const atualizarStatus = setTimeout(() => {
            buscarTitulosGerados(dataInicial, dataFinal, setDataInicial, setDataFinal, setTitulos, dataInicialAlterada, dataFinalAlterada)
          }, 10000)
          setValorSetTimeOut(Number(atualizarStatus))
        } else {
          setCarregarBotao(false)
          setDataInicial(dataInicialAlterada)
          setDataFinal(dataFinalAlterada)
          setTitulos(response)
        }
      })
      .catch((e: Error) => {
        toast.error(msgConstants.TITULOS.erroTitulos + e.message)
        setCarregarBotao(false)
      })
  }

  const buscaConstanteTitulos = (valorTitulos: ValorGerados, buscarRelatorioTitulo: () => Promise<void>) => {
    if (valorTitulos.resumoGeral) {
      const statusResumoGeral = valorTitulos.resumoGeral.processamentoRelatorio?.status
      const statusResumoParceiros = valorTitulos.resumoParceiros.map((parceiro) => parceiro.processamentoRelatorio?.status)

      if (statusResumoGeral == StatusProcessamento.PROCESSANDO || statusResumoParceiros.includes(StatusProcessamento.PROCESSANDO)) {
        clearTimeout(valorSetTimeOut)
        const atualizarStatus = setTimeout(() => {
          buscarRelatorioTitulo()
        }, 10000)
        setValorSetTimeOut(Number(atualizarStatus))
      }
    }
  }

  const estadoInicialTela = () => {
    dispatch(loadingUpdate(true))
    TitulosManager.buscarTitulosGerados(dataInicialMesAtual, diaAtual)
      .then((response: ValorGerados) => {
        setarRetorno(response)
      })
      .catch((e: Error) => {
        toast.error(msgConstants.TITULOS.erroTitulos + e.message)
      })
      .finally(() => {
        dispatch(loadingReset())
      })
  }

  const atualizarDadosDataAtual = () => {
    dispatch(loadingUpdate(true))
    TitulosManager.buscarTitulosGerados(diaAtual, diaAtual, true)
      .then((response: ValorGerados) => {
        setarRetorno(response)
      })
      .catch((e: Error) => {
        toast.error(msgConstants.TITULOS.erroTitulos + e.message)
      })
      .finally(() => {
        dispatch(loadingReset())
      })
  }

  function setarRetorno(response: ValorGerados) {
    setTitulosGerados(response)
    setDataInicialTitulosGerados(dataInicialMesAtual)
    setDataFinalTitulosGerados(diaAtual)
  }

  const handleBuscarTitulos = async (data: BuscarTitulosForm) => {
    clearTimeout(valorSetTimeOut)
    if (data.dataPeriodo !== dataInicialTitulosGerados || data.dataComparacao !== dataFinalTitulosGerados) {
      setCarregarBotao(true)
      buscarTitulosGerados(
        data.dataPeriodo,
        data.dataComparacao,
        setDataInicialTitulosGerados,
        setDataFinalTitulosGerados,
        setTitulosGerados,
        dataInicialTitulosGeradosAlterada,
        dataFinalTitulosGeradosAlterada
      )
    }
  }

  const mapearResumoTitulosGerados = (cardTitulos: CardTitulos) => {
    if (cardTitulos.informacoes) {
      return (
        cardTitulos.informacoes &&
        cardTitulos.informacoes.map((informacao) => {
          return {
            tooltip: 'Fazer download do relatório dos títulos gerados',
            titulo: informacao.nome,
            valor: informacao.valor,
            quantidade: informacao.quantidade,
            primeiroCard: true,
            status: cardTitulos.processamentoRelatorio?.status,
            url: cardTitulos?.urlRelatorio
          }
        })
      )
    }
    return []
  }

  const exportarRelatorioPeriodo = (dataInicio: string, parceiroId?: number, dataFim?: string) => {
    return gerarRelatorioTitulosGerados(() => handleBuscarTitulosGerados(), dataInicio, parceiroId, dataFim)
  }

  return {
    styles: titulosGeradosStyles,
    titulosGerados,
    mapearResumoTitulosGerados,
    handleBuscarTitulos,
    exportarRelatorioPeriodo,
    atualizarDadosDataAtual
  }
}

export type TitulosGeradosIO = ReturnType<typeof titulosGeradosIO>
